import { render } from "./PercentageDisplay.vue?vue&type=template&id=47d7fac0&scoped=true"
import script from "./PercentageDisplay.vue?vue&type=script&lang=js"
export * from "./PercentageDisplay.vue?vue&type=script&lang=js"

import "./PercentageDisplay.vue?vue&type=style&index=0&id=47d7fac0&lang=less&scoped=true"

import exportComponent from "/app/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-47d7fac0"]])

export default __exports__